module.exports = __webpack_public_path__ + "/hashedassets-launcher/v3/logo_teams2025.f8378212df0593756c9c2e9d0a530994.svg";